<!-- main content -->
<p-table stripedRows #dataTable
    [value]="items"
    virtualScroll="true"
    dataKey="SIListID"
    [(selection)]="selected"
    (selectionChange)="SelectItem.next(selected)"
    [scrollable]="true"
    scrollHeight="flex"
    [tableStyle]="{ 'min-width': '80em', height: 'unset' }"
>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="8" style="text-align: center">
                <div class="tabulator-placeholder">
                    <span> No Data Available </span>
                </div>
            </td>
        </tr>
    </ng-template>

    <ng-template #header let-item>
        <!-- Column Header/Sorting -->
        <tr>
            <!-- Status -->
            <th class="status-cell">
                <i
                    class="pi pi-exclamation-circle"
                    title="Status"
                ></i>
            </th>
            <th class="select-cell">
                <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
            </th>
            <!-- Service Item -->
            <th>
                Service Item
                    <p-sortIcon
                        pSortableColumn="ServiceItem"
                        field="ServiceItem"
                        ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"
                    ></p-sortIcon>
                    <p-columnFilter field="SIListID" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false" class="ml-auto">
                        <ng-template #filter let-value let-filter="filterCallback">
                            <p-multiSelect
                                defaultLabel="Filter"
                                maxSelectedLabels="1"
                                appendTo="body"
                                [options]="serviceItemsSelectItems"
                                [filter]="true"
                                styleClass="w-full"
                                [ngModel]="value"
                                (ngModelChange)="filter($event)"
                            ></p-multiSelect>
                        </ng-template>
                    </p-columnFilter>
            </th>
            <!-- Description -->
            <th>
                Description
                    <p-sortIcon
                        pSortableColumn="ServiceItemDescription"
                        field="ServiceItemDescription"
                        ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"
                    ></p-sortIcon>
                    <p-columnFilter type="text" matchMode="contains" field="ServiceItemDescription" display="menu" class="ml-auto" />
            </th>
            <!-- Account -->
            <th>
                Account
                    <p-sortIcon
                        pSortableColumn="Account"
                        field="Account"
                        ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"
                    ></p-sortIcon>
                    <p-columnFilter type="text" matchMode="contains" field="Account" display="menu" class="ml-auto" />
            </th>
            <!-- Service Item Cost -->
            <th>
                Service Item Cost
                    <p-sortIcon
                        pSortableColumn="Serviceitemcost"
                        field="Serviceitemcost"
                        ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"
                    ></p-sortIcon>
            </th>
            <!-- Service item Price -->
            <th>
                Service Item Price
                    <p-sortIcon
                        pSortableColumn="Serviceitemprice"
                        field="Serviceitemprice"
                        ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"
                    ></p-sortIcon>
            </th>
            <!-- Display Service Item Rate -->
            <th>
                Display Service Item Rate
                <p-sortIcon
                        pSortableColumn="DisplaySIRate"
                        field="DisplaySIRate"
                        ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"
                    ></p-sortIcon>
            </th>
            <!-- Leave Request SI -->
            <th title="Service item used for approved leave request authorizations.">
                Leave Request Item
                <p-sortIcon
                        pSortableColumn="IsLeaveRequestSI"
                        field="IsLeaveRequestSI"
                        ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"
                    ></p-sortIcon>
            </th>
        </tr>
    </ng-template>
    <ng-template #body let-item>
        <tr
            [pSelectableRow]="item"
            data-id="row-{{ item.SIListID }}"
        >
            <!-- Status -->
            <td class="status-cell">
                <div (click)="onStatusClick(item)" class="status-cell">
                    <ef-status-icon
                        [status]="item?.Status?.StatusCode"
                        [message]="item?.Status?.Message"
                    ></ef-status-icon>
                </div>
            </td>
            <!-- Selection -->
            <td class="select-cell">
                <p-tableCheckbox [value]="item"></p-tableCheckbox>
            </td>
            <!-- Service Item -->
            <td class="disabled text-nowrap-ellipsis" [title]="item?.ServiceItem">
                {{ item?.ServiceItem }}
            </td>
            <!-- Description -->
            <td class="disabled text-nowrap-ellipsis" [title]="item?.ServiceItemDescription">
                {{ item?.ServiceItemDescription }}
            </td>
            <!-- Account -->
            <td class="disabled text-nowrap-ellipsis" [title]="item?.Account">
                {{ item?.Account }}
            </td>
            <!-- Service Item Cost -->
            <td class="disabled">
                {{ item?.Serviceitemcost | currency }}
            </td>
            <!-- Service item Price -->
            <td class="disabled">
                {{ item?.Serviceitemprice | currency }}
            </td>
            <!-- Display Service Item Rate -->
            <td
                class="checkbox"
                [pEditableColumn]="item"
                [pEditableColumnField]="'DisplaySIRate'"
            >
                <div>
                    <p-checkbox
                        [disabled]="item.IsReadOnly"
                        binary="true"
                        type="checkbox"
                        [(ngModel)]="item.DisplaySIRate"
                        (onChange)="onEditComplete({ data: item })"
                    ></p-checkbox>
                </div>
            </td>
            <!-- Leave Request SI -->
            <td
                class="checkbox"
                [pEditableColumn]="item"
                [pEditableColumnField]="'IsLeaveRequestSI'"
            >
                <div>
                    <p-checkbox
                        [disabled]="item.IsReadOnly"
                        binary="true"
                        type="checkbox"
                        [(ngModel)]="item.IsLeaveRequestSI"
                        (onChange)="onEditComplete({ data: item })"
                    ></p-checkbox>
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>
